import createReactComponent from '../createReactComponent';
export default createReactComponent('yen', 'Yen', [["path",{"d":"M17.455 12H12m0 0H6.545M12 12 6 3.5m6 8.5 6-8.5M12 12v4.25m5.454 0H12m0 0H6.545m5.455 0v4.25","key":"svg-0"}]]);